import styled from 'styled-components'
import { Card } from 'reactstrap'

export default styled(Card)`
  .card-body {
    background-color: ${props => props.theme.colors.dark0};
    color: white;
  }
`
